import { Toggle } from '@pandiafi/design-system'
import { Field, FieldProps } from 'formik'
import { t } from 'i18next'
import React from 'react'

import FormFieldWrapper from 'components/FormField'
import { FormValues } from 'views/TerminateContract/TerminateForm/initialValues'

export const HasPetsInApartmentField = () => {
  return (
    <Field name="hasPetsInApartment">
      {({
        field,
        meta,
        form,
      }: FieldProps<FormValues['hasPetsInApartment']>) => (
        <FormFieldWrapper name={field.name} meta={meta} labelBold>
          <Toggle
            checked={meta.value}
            labelPosition="left"
            onChange={(value) => form.setFieldValue(field.name, value)}
          >
            {t('terminateContract:labels.hasPetsInApartment')}
          </Toggle>
        </FormFieldWrapper>
      )}
    </Field>
  )
}
